import { render, staticRenderFns } from "./AbsApp.vue?vue&type=template&id=28a981b3&scoped=true"
import script from "./AbsApp.vue?vue&type=script&lang=js"
export * from "./AbsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a981b3",
  null
  
)

export default component.exports